import { render, staticRenderFns } from "./PaymentRefundBanner.vue?vue&type=template&id=1a2d9fd0&scoped=true"
import script from "./PaymentRefundBanner.vue?vue&type=script&lang=js"
export * from "./PaymentRefundBanner.vue?vue&type=script&lang=js"
import style0 from "./PaymentRefundBanner.vue?vue&type=style&index=0&id=1a2d9fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d9fd0",
  null
  
)

export default component.exports